import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Services } from "appworks/services/services";
import { RadioControl } from "appworks/ui/controls/standard/radio/radio-control";
import { slotModel } from "slotworks/model/slot-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class AgsTotalCreditsRadioControl extends RadioControl {
    protected onModelUpdateCallback: Function;

    constructor(
        buttons: FlexiButton[],
        labels: FlexiText[],
        leftArrow?: FlexiButton,
        rightArrow?: FlexiButton
    ) {
        super(buttons, labels, leftArrow, rightArrow);

        this.updateValues();

        this.disabledTextAlpha = 1;

        this.onModelUpdateCallback = () => this.updateValues();
        slotModel.onUpdate.add(this.onModelUpdateCallback);
    }

    public destroy(): void {
        super.destroy();
        slotModel.onUpdate.remove(this.onModelUpdateCallback);
    }

    public setEnabled(enabled: boolean): void {
        const { freeBet } = slotModel.read().bet;

        // Never enable stepper during free bets
        if (freeBet) {
            super.setEnabled(false);
        } else {
            super.setEnabled(enabled);
        }
    }

    public updateValues(): void {
        const { bet } = slotModel.read();
        this.setValues(bet.creditsPerLine.values, bet.creditsPerLine.currentValue);
    }

    protected onChange(index: number, value: number): void {
        super.onChange(index, value);
        Services.get(SlotBetService).setCreditPerLine(value);
    }
}
